export default __webpack_public_path__ + "static/media/like.ec3e5916.png";